import { getField, updateField } from 'vuex-map-fields';
import i18n from '@rmdy/rmdy-translations-frontend';
import roleService from './role.service';

const role = {
	namespaced: true,
	state: {
		roles: [],
		isSearchingRoles: false,
		setIsSavingRole: false,
	},
	getters: {
		getField,
	},
	actions: {
		async getAllRoles({ commit, dispatch }) {
			commit('setIsSearchingRoles', true);
			try {
				const result = await roleService.getAllRoles();
				commit('setRoles', result.data);
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSearchingRoles', false);
		},
		async getRoleById({ commit, dispatch }, id) {
			commit('setIsSearchingRoles', true);
			try {
				const result = await roleService.getRoleById(id);
				commit('setRoleDetails', result.data);
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSearchingRoles', false);
		},
		async createRole({ dispatch, commit }, roleDetail) {
			commit('setIsSavingRole', true);
			try {
				await roleService.createRole(roleDetail);
				dispatch('getAllRoles');
				dispatch('toast/makeToast', { message: 'admin.item-saved' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSavingRole', false);
		},
		async updateRole({ dispatch, commit }, roleDetail) {
			commit('setIsSavingRole', true);
			try {
				await roleService.updateRole(roleDetail);
				dispatch('getAllRoles');
				dispatch('toast/makeToast', { message: 'admin.item-updated' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSavingRole', false);
		},
		async deleteRole({ state, dispatch, commit }, roleId) {
			try {
				const roleToDelete = state.roles.find(oldRole => oldRole._id === roleId);
				if (roleToDelete && roleToDelete.count === 0) {
					await roleService.deleteRole(roleId);
					commit('setRoles', Array.of(...state.roles.filter(oldRole => oldRole._id !== roleId)));
					dispatch('toast/makeToast', { message: 'admin.item-removed' }, { root: true });
				} else {
					dispatch('toast/makeToast', {
						message: i18n.i18n.t('roles.store.error.role-user-count'),
						type: 'error',
					}, { root: true });
				}
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data.message,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
		},
	},
	mutations: {
		updateField,
		setRoles(state, roles) {
			state.roles = roles;
		},
		setIsSearchingRoles(state, searchState) {
			state.isSearchingRoles = searchState;
		},
		setIsSavingRole(state, saveState) {
			state.isSavingRole = saveState;
		},
	},
};

export default role;
